export default __webpack_public_path__ + "static/media/1.5d0961b0.png";